import React from "react";

const ImageUploader = ({
    label,
    spam,
    error,
    image,
    setImage,
    removeImage,
    name,
    setValue,
    register,
}) => {

    const handleImageUpload = (e) => {
        const file = e.target.files[0];
        if (file) {
            const imageUrl = URL.createObjectURL(file);
            setImage(imageUrl);
            setValue(file); // Actualiza el valor del campo en el formulario
        }
    };

    return (
        <div className={`flex text-start flex-col w-full cols cols-1`}>
            <label className="text-sm flex items-center m-1 font-semibold">
                <p>{label}</p>
                {spam && <span className="text-red-500">*</span>}
            </label>
            <div className="flex flex-col items-center justify-center p-3 bg-blue-50 rounded-2xl shadow-lg max-w-md mx-auto">
                {!image ? (
                    <label className="w-full cursor-pointer flex flex-col items-center justify-center border-2 border-dashed border-blue-400 p-6 rounded-xl hover:bg-blue-100 transition">
                        <svg
                            className="w-12 h-12 text-blue-500 mb-2"
                            fill="none"
                            stroke="currentColor"
                            strokeWidth="2"
                            viewBox="0 0 24 24"
                        >
                            <path d="M4 16v2a2 2 0 002 2h12a2 2 0 002-2v-2M7 10l5-5m0 0l5 5m-5-5v12" />
                        </svg>
                        <p className="text-blue-600 font-medium">Haz clic para subir una imagen</p>
                        <input
                            type="file"
                            accept="image/*"
                            className="hidden"
                            {...register(name, { required: true })}
                            onChange={handleImageUpload}
                        />
                    </label>
                ) : (
                    <div className="relative">
                        <img
                            src={image}
                            alt="Uploaded"
                            className="rounded-xl shadow-md max-h-40 object-cover"
                        />
                        <button
                            type="button"
                            onClick={() => removeImage()}
                            className="absolute top-2 right-2 bg-red-400 text-white rounded-full p-1 w-8 h-8 hover:bg-red-500 transition"
                        >
                            ✕
                        </button>
                    </div>
                )}
            </div>
            {error}
        </div>
    );
};

export default ImageUploader;
